import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
const TOTAL_SECONDS = 2 * 60 * 60; // 2 hours

interface TimeBlockProps {
  value: number;
  label: string;
}
function TimeBlock({
  value,
  label
}: TimeBlockProps) {
  const display = value.toString().padStart(2, '0');
  return <div className="flex flex-col items-center" data-id="element-235" data-mp="1od1slcea5zxk">
      <div className="relative" data-id="element-236" data-mp="1oc8j43nxswbq">
        <motion.span key={display} initial={{
        scale: 0.96,
        opacity: 0.7
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex items-center justify-center min-w-[64px] md:min-w-[76px] px-3 py-3 md:py-4 rounded-2xl bg-brand-pink text-white font-serif font-bold text-3xl md:text-4xl tabular-nums shadow-glow ring-2 ring-brand-black/10" data-id="element-237" data-mp="1kawyydnu13ax">
          {display}
        </motion.span>
      </div>
      <span className="text-[10px] md:text-xs uppercase tracking-widest mt-2 text-brand-black/60 font-semibold" data-id="element-238" data-mp="2zrx6gw53rxd2">
        {label}
      </span>
    </div>;
}
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <div className="inline-flex items-center gap-2 md:gap-3 my-4" role="timer" aria-live="off" aria-label={`La oferta termina en ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-239" data-mp="1ut9edneib6p9">
      <TimeBlock value={hours} label="Horas" data-id="element-240" data-mp="1q0g8uxb7ruc4" />
      <span className="text-2xl md:text-3xl font-bold text-brand-pink pb-6" data-id="element-241" data-mp="1pzeno00hhrgo">
        :
      </span>
      <TimeBlock value={minutes} label="Min" data-id="element-242" data-mp="2dp8wm6homvvn" />
      <span className="text-2xl md:text-3xl font-bold text-brand-pink pb-6" data-id="element-243" data-mp="2do7nw8o52lh3">
        :
      </span>
      <TimeBlock value={seconds} label="Seg" data-id="element-244" data-mp="2iilhq6n5kkjn" />
    </div>;
}